<div class="loyalty-sign-in-container" [class.pb-32]="isSocialAuthEnabled()">
  <app-textbox
    [label]="localeObj().tf_1_Calendar_Loyalty_signIn_usernameOrPin"
    type="text"
    [placeholder]="localeObj().tf_1_Calendar_Loyalty_signIn_usernameOrPin"
    [bindValue]="usernameOrPin()"
    (onChange)="handleUsernameChange($event)"
    [disabled]="isLoginInProgress() || isSSOLoginInProgress()"
    (onKeyUp)="handleKeyUp($event)"
  />
  <div class="position-relative">
    <app-textbox
      [label]="localeObj().tf_1_Calendar_Loyalty_signIn_password"
      [placeholder]="localeObj().tf_1_Calendar_Loyalty_signIn_password"
      [type]="showPassword() ? 'text' : 'password'"
      [bindValue]="password()"
      (onChange)="handlePasswordChange($event)"
      [disabled]="isLoginInProgress() || isSSOLoginInProgress()"
      (onKeyUp)="handleKeyUp($event)"
    />
    <app-button
      variant="link"
      iconDisplay="icon-only"
      customClass="password-toggle-icon"
      [icon]="showPassword() ? 'fa-light fa-eye-slash' : 'fa-light fa-eye'"
      [ariaLabel]="
        showPassword() ? localeObj().tf_1_Calendar_Loyalty_hidePassword : localeObj().tf_1_Calendar_Loyalty_showPassword
      "
      [label]="''"
      (onClickEvent)="togglePasswordVisibility()"
    />
  </div>

  <app-button
    variant="primary"
    fullWidth
    [label]="localeObj().tf_1_Calendar_Loyalty_btn_SignIn"
    (onClickEvent)="handleSignIn(false)"
    [isDisabled]="isLoginInProgress() || isSSOLoginInProgress() || !usernameOrPin() || !password()"
    [isLoading]="isLoginInProgress()"
    class="d-block mb-4"
  />
  @if (propInfo().loyaltySignUpSettingsInfo?.enable_signup_api) {
    <app-button
      variant="link"
      [label]="localeObj().tf_1_Calendar_Loyalty_signIn_forgotPassword"
      (onClickEvent)="handleForgotPassword()"
      [isDisabled]="isLoginInProgress() || isSSOLoginInProgress()"
      class="d-block text-center"
    />
  } @else if (propInfo().signupLink && !propInfo().loyaltySignUpSettingsInfo?.enable_signup_api) {
    <div class="px-1 mt-3 d-flex justify-content-between align-items-center flex-column">
      <span
        [innerHTML]="localeObj().tf_1_Calendar_ExtLoyalty_signIn_troubleLoggingInTxt"
      ></span>
      <app-button
        variant="link"
        [label]="localeObj().tf_1_Calendar_ExtLoyalty_signIn_manageUsernameorPswdLinkTxt"
        (onClickEvent)="navigateToSignupLink()"
        class="d-block text-center"
      />
    </div>
  }
</div>

@if (isSocialAuthEnabled()) {
  <div class="social-login-container">
    <div class="or-divider d-flex align-items-center justify-content-center" [attr.data-direction]="'horizontal'">
      @if (isDesktop()) {
        <div class="line"></div>
      }
      <div [class.px-3]="isDesktop()" [innerHTML]="localeObj().tf_1_Calendar_Loyalty_signIn_socialLogin"></div>
      @if (isDesktop()) {
        <div class="line"></div>
      }
    </div>
    <div class="social-login-buttons d-flex gap-3 align-items-center justify-content-center pt-32">
      @if (isGoogleSDKLoaded()) {
        <app-button
          [label]="_storeSvc.localeObj()?.tf_5_Loyalty_signin_google"
          iconDisplay="icon-only"
          [iconSrc]="socialLoginSVG.GOOGLE"
          (onClickEvent)="signInWithSocialAccount('GOOGLE')"
          [isDisabled]="isSocialAuthInProgress() || !isGoogleSDKLoaded()"
          [isLoading]="isGoogleAuthInprogress()"
        />
      }
      @if (isFacebookSDKLoaded()) {
        <app-button
          [label]="_storeSvc.localeObj()?.tf_5_Loyalty_signin_facebook"
          iconDisplay="icon-only"
          [iconSrc]="socialLoginSVG.FACEBOOK"
          (onClickEvent)="signInWithSocialAccount('FACEBOOK')"
          [isDisabled]="isSocialAuthInProgress() || !isFacebookSDKLoaded()"
          [isLoading]="isFacebookAuthInprogress()"
        />
      }
      @if (isAppleSDKLoaded()) {
        <app-button
          [label]="_storeSvc.localeObj()?.tf_5_Loyalty_signin_apple"
          iconDisplay="icon-only"
          [iconSrc]="socialLoginSVG.APPLE"
          (onClickEvent)="signInWithSocialAccount('APPLE')"
          [isDisabled]="isSocialAuthInProgress() || !isAppleSDKLoaded()"
          [isLoading]="isAppleAuthInprogress()"
        />
      }
      @if (isAmazonSDKLoaded()) {
        <app-button
          [label]="_storeSvc.localeObj()?.tf_5_Loyalty_signin_amazon"
          iconDisplay="icon-only"
          [iconSrc]="socialLoginSVG.AMAZON"
          (onClickEvent)="signInWithSocialAccount('AMAZON')"
          [isDisabled]="isSocialAuthInProgress() || !isAmazonSDKLoaded()"
          [isLoading]="isAmazonAuthInprogress()"
        />
      }
    </div>
  </div>
}

@if (propInfo().loyaltySignUpSettingsInfo?.enable_signup_api) {
  @if (context() !== 'side-panel') {
    <app-card class="pt-40 d-block" [padding]="0" [marginBottom]="0" classes="px-32 pb-32">
      <ng-container *ngTemplateOutlet="loyaltySignUpContent"></ng-container>
    </app-card>
  } @else {
    <ng-container *ngTemplateOutlet="loyaltySignUpContent"></ng-container>
  }
}

<ng-template #loyaltySignUpContent>
  <div
    class="loyalty-sign-up-container py-32"
    [class.custom-border-top]="context() === 'side-panel'"
    [class.mt-32]="context() === 'side-panel'"
  >
    <h5 class="pb-4 mb-0" [innerHTML]="localeObj().tf_1_Calendar_Loyalty_signIn_NotaMember"></h5>
    <ul class="sign-up-features d-flex flex-column ps-3 gap-2 mb-0">
      <li [innerHTML]="localeObj().tf_1_Calendar_Loyalty_signIn_Specialpromotions"></li>
      <li [innerHTML]="localeObj().tf_1_Calendar_Loyalty_signIn_Fastercheckout"></li>
      <li [innerHTML]="localeObj().tf_1_Calendar_Loyalty_signIn_Accessyourreservations"></li>
      <li [innerHTML]="localeObj().tf_1_Calendar_Loyalty_signIn_Earnpointsperstays"></li>
    </ul>
  </div>
  <app-button
    class="sign-up-button d-block"
    variant="secondary"
    fullWidth
    [label]="localeObj().tf_10_Loyalty_signUp_BecomeAMember"
    (onClickEvent)="handleSignUpSidePanel()"
  />
</ng-template>
